import { render, staticRenderFns } from "./panel-product-item.vue?vue&type=template&id=13e6b06c&scoped=true"
import script from "./panel-product-item.vue?vue&type=script&lang=js"
export * from "./panel-product-item.vue?vue&type=script&lang=js"
import style0 from "./panel-product-item.vue?vue&type=style&index=0&id=13e6b06c&prod&scoped=true&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "13e6b06c",
  null
  
)

export default component.exports